import { render, staticRenderFns } from "./ViewSupplierContainer.vue?vue&type=template&id=259d3106&scoped=true&"
import script from "./ViewSupplierContainer.vue?vue&type=script&lang=js&"
export * from "./ViewSupplierContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259d3106",
  null
  
)

export default component.exports